import { authHeader, host } from '../_helpers';
import axios from 'axios';


export const cs2Service = {
	getExecutions,
	getSubmissionLogs,
	fileSubmission,
	getFirmGroupList
};

/* TODO 
 *  config the url for each environment, remove hard code localhost
 */

function getExecutions_fetch(tdate) {
	
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    
    return fetch(`${host}/CS2Services/submissions/` + tdate, requestOptions)
        .then(handleResponse)
        .then(executions => {
        	
            return executions;
        });
}

function fileSubmission(xmlString) {
	
	//adding more attributes
	let submissionHeader = { ...authHeader(), 'Content-type': 'text/plain' }
	
    return axios.post(`${host}/CS2Services/submissions/upload`, xmlString, { headers: submissionHeader })
    .then(response => {
    	return response.data;
    })
	
}

function getExecutions(tdate) {

	    return axios.get(`${host}/CS2Services/submissions/${tdate}`, { headers: authHeader() })
	        .then(response => response.data);
		

}

function getSubmissionLogs() {
	
	return axios.get(`${host}/CS2Services/submissionlogs`, { headers: authHeader() })
		.then(response => response.data)
}

function getFirmGroupList() {
	
	return axios.get(`${host}/CS2Services/firmgroup`, { headers: authHeader() })
		.then(response => response.data)
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                location.reload(true);
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        //console.log("handleResponse in cs2 service: "+ JSON.stringify(data));
        return data;
    });
}